import React from 'react';
import { useAuth } from './AuthContext';
import Login from './Login';
import AppChatGPT from './AppChatGPT';

export default function MainApp() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#202123',
        color: '#fff',
        fontSize: '1.2rem'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '60px',
            height: '60px',
            border: '4px solid rgba(16, 163, 127, 0.2)',
            borderTop: '4px solid #10a37f',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }} />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return <AppChatGPT user={user} logout={logout} />;
}
